<template>
    <div>
        <modal ref="modal" size="lg" :has-footer="false" @hidden="close">
            <span slot="title">
                Campaign: {{ campaign.name }}
            </span>
            <div class="text-center" v-if="messages.length">
                <carousel :per-page="1"
                    :navigationEnabled="true"
                    :paginationEnabled="false"
                    navigationNextLabel='<span class="fa fa-arrow-right step-controller"></span>'
                    navigationPrevLabel='<span class="fa fa-arrow-left step-controller"></span>'>
                    <slide v-for="message in messages" :key="message.id">
                        <div class="review-wrapper p-4 h-100">
                            <img class="mw-100 mb-2 rounded img-fluid"
                                 :src="message.image"
                                 v-if="message.image" />

                            <img class="mb-2 rounded img-fluid"
                                 :src="message.image"
                                 v-else-if="campaign.image" />

                            <div class="my-4 text-center" v-html="message.content"></div>
                        </div>
                    </slide>
                </carousel>
            </div>
            <div v-else class="alert alert-warning" role="alert">
                No steps for email messages.
            </div>
        </modal>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        props: {
            campaign  : { required: true },
            messages  : {
                type: Array,
                required: true
            }
        },

        components: {
            Carousel,
            Slide
        },

        methods: {
            open () {
                this.$refs.modal.open();
            },

            close() {
                this.$parent.campaign = {};
                this.$parent.messages = [];
            },
        },
    }
</script>

<style>
    .VueCarousel-navigation {
        text-align: center;
        padding-top: 1rem;
    }

    .VueCarousel-navigation-button {
        display: contents;
    }

    .step-controller {
        font-size:2rem;
        color:#007bff;
    }

    .VueCarousel-navigation--disabled .step-controller {
        opacity: 0.5;
    }
</style>
